import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["defaultMatches", "children"];
import { useEffect, useState } from "react";
import { matchMediaQuery } from "@crehana/utils";
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
// @ts-expect-error  Type 'undefined' is not assignable to type 'ReactElement<any, any> | null'.
export var Media = function Media(_ref) {
  var _ref$defaultMatches = _ref.defaultMatches,
    defaultMatches = _ref$defaultMatches === void 0 ? false : _ref$defaultMatches,
    children = _ref.children,
    mediaQueryOptions = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(defaultMatches),
    _useState2 = _slicedToArray(_useState, 2),
    matches = _useState2[0],
    setMatches = _useState2[1];
  useEffect(function () {
    var nativeMediaQueryList = matchMediaQuery(mediaQueryOptions);
    setMatches(nativeMediaQueryList.matches);
    function listener(event) {
      setMatches(event.matches);
    }
    if (typeof nativeMediaQueryList.addEventListener === 'function') {
      nativeMediaQueryList.addEventListener('change', listener);
    } else if (typeof nativeMediaQueryList.addListener === 'function') {
      nativeMediaQueryList.addListener(listener);
    }
    return function () {
      if (typeof nativeMediaQueryList.removeEventListener === 'function') {
        nativeMediaQueryList.removeEventListener('change', listener);
      } else if (typeof nativeMediaQueryList.removeListener === 'function') {
        nativeMediaQueryList.removeListener(listener);
      }
    };
  }, [mediaQueryOptions]);
  if (typeof children === 'function') {
    return children(matches);
  }
  if (!matches) {
    return null;
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
export default Media;